import Hero from "@/components/home/Hero";
import TrustStrip from "@/components/home/TrustStrip";
import ProductSlideshow from "@/components/home/ProductSlideshow";
import MasterBrandShowcase from "@/components/home/MasterBrandShowcase";
import AboutSection from "@/components/home/AboutSection";
import Timeline from "@/components/home/Timeline";
import MissionVisionValues from "@/components/home/MissionVisionValues";
import ProductsShowcase from "@/components/home/ProductsShowcase";
import WhyChooseSBC from "@/components/home/WhyChooseSBC";
import ExportMap from "@/components/home/ExportMap";
import { LIFESTYLE } from "@/data/products";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Home() {
  return (
    <div data-testid="home-page">
      <ProductSlideshow />
      <Hero />
      <TrustStrip />
      <MasterBrandShowcase />
      <AboutSection />
      <ProductsShowcase />
      <MissionVisionValues />
      <Timeline />
      <WhyChooseSBC />
      <ExportMap />

      {/* CTA Band */}
      <section className="py-20 bg-background" data-testid="home-cta-band">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-4">
            <Link to="/distributor" className="group relative overflow-hidden rounded-3xl bg-neutral-950 text-white p-10 min-h-[280px] flex flex-col justify-between">
              <img src={LIFESTYLE.handshake} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25 group-hover:opacity-40 transition-opacity" />
              <div className="relative">
                <div className="eyebrow text-gold-400 mb-3">Become a Distributor</div>
                <h3 className="font-display font-bold text-3xl">Partner with SBC in your market.</h3>
              </div>
              <div className="relative inline-flex items-center gap-2 text-gold-400 font-semibold">Apply Now <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></div>
            </Link>
            <Link to="/investors" className="group relative overflow-hidden rounded-3xl bg-gold-400 text-neutral-950 p-10 min-h-[280px] flex flex-col justify-between">
              <div className="relative">
                <div className="text-[10px] uppercase tracking-[0.24em] font-bold mb-3">Investor Relations</div>
                <h3 className="font-display font-bold text-3xl">A generational beverage company in the making.</h3>
              </div>
              <div className="relative inline-flex items-center gap-2 font-semibold">Explore Investor Hub <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
